
import React, { useState, useEffect } from "react";
import ClientPagination from "./components/ClientPagination";
import Clients from "./components/Clients";
import { DESK_CLIENT_SEARCH, DESK_CLIENT_PAGINATE } from 'src/constants/EndpointUrls';
import { concatParamsToUrl, redirectTo } from 'src/utils/Http';


const ClientsPage = (props) => {

	const clients = props.clients;
	const totalClient = props.clientsLength;
	const PerPage = props.clientPerPage;
	const current = props.currentPage;
	const [nameSearch, setNameSearch] = useState("");
	const [planTypeSearch, setPlanTypeSearch] = useState("");
	const [name, setName] = useState("");
	const [planType, setPlanType] = useState("");
	const [currentPage, setCurrentPage] = useState(1);
	const [clientPerPage] = useState(PerPage);
    const indexOfLastClient = currentPage * clientPerPage;
    const indexOfFirstClient = indexOfLastClient - clientPerPage;
    const currentClient = clients.slice(indexOfFirstClient, indexOfLastClient);

	const setSearchTerm = (e) => {
		setNameSearch(e.target.value);
		e.preventDefault();
	};

	const setSearchPlanType = (e) => {
		setPlanTypeSearch(e.target.value);
		e.preventDefault();
	};

	const handleSearch = (nameSearch, planTypeSearch) => {
		redirectTo(concatParamsToUrl(DESK_CLIENT_SEARCH, { q: nameSearch, plan_type: planTypeSearch }))
	};
    return (
        <div className="top-container container-fluid">
			<h2>クライアント一覧</h2>
			<div className="u-mb15 text-right">
				{/* waiting for CSV function for Front-end */}
				<a href="" className="btn btn-outline-success mr-1">CSVエクスポート</a>
				<a href="/desk/registration/new" className="btn btn-primary">アカウント登録</a>
			</div>
			<div className="u-mb15 d-flex justify-content-between align-items-center flex-column flex-lg-row">
				<div className="u-mb15">
					<div className="form-inline">
						<div className="mr-2 d-flex p-3">
							<label className="mr-1" htmlFor="q" >会社名</label>
							<input className="form-control" id="q" name="q" type="text" onChange={setSearchTerm} placeholder="会社名"/>
						</div>
						<div className="mr-2 d-flex p-3">
							<label className="mr-1" htmlFor="plan_type" >プラン</label>
							<select className="form-control" aria-label="Default select example" onChange={setSearchPlanType}>
								<option defaultValue value=""></option>
								<option value="free_plan">無料プラン</option>
								<option value="paid_plan">有料プラン</option>
								<option value="suspended">アカウント停止</option>
								<option value="trial_plan">お試しプラン</option>
							</select>
						</div>

						<button className="form-control btn btn-primary" onClick={() => handleSearch(nameSearch, planTypeSearch)}> 検 索 </button>
					</div>
				</div>
				<div className="">
					<ClientPagination clientPerPage={clientPerPage} totalClients={totalClient} currentPage={current} url={DESK_CLIENT_PAGINATE} />
				</div>
			</div>
				<Clients currentClient={currentClient} name={name} planType={planType} />
		</div>
    );
}


export default ClientsPage;
